// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://gmwpxeurfokmgxliijfh.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imdtd3B4ZXVyZm9rbWd4bGlpamZoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzcyODU3ODcsImV4cCI6MjA1Mjg2MTc4N30.BmZSgLHixd5vjbP6Qy-Rdua3U-uD6gT8WNUdLE0Jf6c";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);